export class TripEventType {
  public id = '';

  public name = '';

  public code = '';
}
